module.exports = __webpack_public_path__ + "media/images/products/retailers-newsletter-1-hero-27ae059f3fcd5612bec9dab48351cc8c.jpg";